import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "store";

export type TranslationServiceStatus = "idle" | "loaded" | "failed";

interface TranslationServiceState {
  status: TranslationServiceStatus;
}

const initialState: TranslationServiceState = {
  status: "idle",
};

const translationServiceSlice = createSlice({
  name: "translationService",
  initialState,
  reducers: {
    setTranslationServiceStatus(state, action: PayloadAction<TranslationServiceStatus>) {
      state.status = action.payload;
    },
  },
});

export const { setTranslationServiceStatus } = translationServiceSlice.actions;

export const selectTranslationServiceStatus = (state: RootState) => state.translationService.status;

export default translationServiceSlice.reducer;
